import styled from 'styled-components'

export const ResourceListsContainer = styled.section.attrs((props: any) => ({
  isDarkTheme: props.isDarkTheme,
  topPaddingSize: props.topPaddingSize,
  bottomPaddingSize: props.bottomPaddingSize,
  backgroundColor: props.backgroundColor,
}))`
  .ResourceLists__Grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  ${({ theme, isDarkTheme, topPaddingSize, bottomPaddingSize, backgroundColor }) => {
    const black = theme.webMktPalette.text.primaryBlack
    const white = theme.webMktPalette.text.primaryWhite

    return `
      background-color: ${backgroundColor};
      padding-top: ${topPaddingSize}px;
      padding-bottom: ${bottomPaddingSize}px;

      .text {
        color: ${isDarkTheme ? white : black};
      }

      .ResourceLists__Button {
        border: 2px solid ${isDarkTheme ? white : black};
      }

      ${theme.breakpoints.down('xs')} {
        .ResourceLists__Grid {
          display: grid;
          grid-template-columns: 100%;
  
          .ResourceLists__ButtonWrapper {
            margin: auto;
            margin-top: 40px;
            grid-row: 4 / 4;
          }
        }
      }
    `
  }};
`

export const Categories = styled.div.attrs((props: any) => ({
  isDarkTheme: props.isDarkTheme,
}))`
  display: flex;
  gap: 40px;
  width: 100%;

  .ResourceLists__Categories_Left {
    flex: 1;
  }

  .ResourceLists__Categories_Right {
    flex: 1;
  }

  .ResourceLists__Category {
    margin-top: 32px;

    .Category__Header {
      display: flex;
      margin-bottom: 4px;

      .Category_Title {
        margin: auto 0;
      }

      .Category__Icon {
        margin-right: 12px;
      }
    }
  }

  ${({ theme, isDarkTheme }) => {
    const secondary = theme.webMktPalette.text.secondary
    const secondaryDark = theme.webMktPalette.text.secondaryDark

    return `
      border-top: 1px solid ${theme.webMktPalette.grayNeutral[isDarkTheme ? 60 : 30]};
      padding-top: 20px;
      margin-top: 32px;

      .Category__Link {
        display: block;
        color: ${isDarkTheme ? secondaryDark : secondary};
        margin-top: 16px;

        :hover {
          color: ${
            isDarkTheme ? theme.webMktPalette.text.actionDark : theme.webMktPalette.text.actionLight
          };
        }
      }

      ${theme.breakpoints.down('md')} {
        padding-top: 12px;
        margin-top: 36px;

        .ResourceLists__Category {
          margin-top: 40px;
        }
      }

      ${theme.breakpoints.down('xs')} {
        display: flex;
        flex-direction: column;
        grid-row: 3 / 4;
        padding-bottom: 40px;
        margin-top: 16px;
        padding-top: 36px;
        border-bottom: 1px solid ${theme.webMktPalette.grayNeutral[isDarkTheme ? 60 : 30]};

        .ResourceLists__Category:first-child {
          margin-top: 0px;
        }

        .ResourceLists__Category .Category__Header {
          margin-bottom: 0;
        }
      }
    `
  }}
`
